module.exports = __webpack_public_path__ + "img/Einheiten.9c83c15d.svg";